module.exports = {
  language: 'Sprache',
  selectLanguage: 'Sprache auswählen',
  charging: 'Lädt',
  notCharging: 'Lädt nicht',
  advanceSetting: 'Erweiterte Einstellungen',
  chargingDesc: 'Ladevorgang starten, wenn der Batteriestand niedriger als ',
  enabled: 'Aktiviert',
  disabled: 'Deaktiviert',
  onPowerRestore: 'Bei Stromwiederherstellung',
  powerWakeDesc: '** Bitte verwenden Sie zwei unabhängige USB-Ladegeräte, um den Pi & PiSugar separat zu laden, und halten Sie den Netzschalter von PiSugar eingeschaltet. Es wird automatisch eingeschaltet, wenn die externe Stromversorgung wiederhergestellt wird.',
  powerWakeDescFor3: 'PiSugar wird automatisch eingeschaltet, wenn die externe Stromversorgung wiederhergestellt wird.',
  powerWakeOffWarning: 'Sie haben die Wake-on-Power-Restore-Funktion ausgeschaltet. Bitte versorgen Sie den Raspberry Pi nicht separat mit externer Stromversorgung.',
  powerWakeOffTitle: 'Hinweis',
  confirmButtonText: 'Bestätigen',
  wakeUpFeature: 'Geplantes Aufwachen',
  repeat: 'Wiederholen',
  repeatEveryday: 'täglich wiederholen.',
  repeatOn: 'wiederholen am',
  checkAll: 'Alle auswählen',
  clearAll: 'Alle löschen',
  wakeUpDesc: 'Geplantes Aufwachen um',
  wakeUpOffDesc: 'Geplantes Aufwachen aus.',
  buttonFunction: 'Benutzerdefinierte Tastenfunktion',
  singleTapLabel: 'Einfacher Klick',
  doubleTapLabel: 'Doppelklick',
  longTapLabel: 'Langer Klick',
  singleTap: 'einfacher Klick',
  doubleTap: 'Doppelklick',
  longTap: 'langer Klick',
  none: 'keine',
  edit: 'Bearbeiten',
  customShell: 'Benutzerdefinierte Shell',
  shutdown: 'Herunterfahren',
  shellModalTitle: {
    single: 'Shell für einfachen Klick ausführen',
    double: 'Shell für Doppelklick ausführen',
    long: 'Shell für langen Klick ausführen'
  },
  shell: 'Shell',
  shellPlaceholder: 'Shell-Skript hier eingeben...',
  cancel: 'Abbrechen',
  confirm: 'Bestätigen',
  triggered: 'Ausgelöst',
  safeShutdown: 'Sicheres Herunterfahren',
  batteryLevel: 'Batteriestand',
  immediately: 'Sofort',
  secondsDelay: 'Sekunden Verzögerung',
  rtcTime: 'RTC-Zeit',
  sysTime: 'Systemzeit',
  syncTime: 'Zeit synchronisieren',
  weekDay: {
    Monday: 'Montag',
    Tuesday: 'Dienstag',
    Wednesday: 'Mittwoch',
    Thursday: 'Donnerstag',
    Friday: 'Freitag',
    Saturday: 'Samstag',
    Sunday: 'Sonntag'
  },
  weekDayShort: {
    Mon: 'Mo',
    Tue: 'Di',
    Wed: 'Mi',
    Thu: 'Do',
    Fri: 'Fr',
    Sat: 'Sa',
    Sun: 'So'
  },
  batteryInputProtect: 'Batterie-Eingangschutz',
  batteryInputProtectDesc: 'Der Ladevorgang wird gestoppt, wenn 60% ~ 80% der Batterie erreicht sind, was die Batterielebensdauer effektiv verlängert.',
  antiMistouch: 'Berührungsschutz',
  antiMistouchDesc: 'Wenn der Berührungsschutz aktiviert ist, muss der Schalter gedrückt und gehalten werden, um ausgelöst zu werden.',
  softPoweroff: 'Sanftes Herunterfahren',
  softPoweroffDesc: 'Die Verwendung des Schalters zum Herunterfahren schaltet nicht direkt ab, sondern der Shutdown-Befehl wird von der Software ausgegeben.',
  softPoweroffShell: 'Sanftes Herunterfahren Shell',
  softPoweroffShellDesc: 'Shell, die ausgeführt wird, wenn das sanfte Herunterfahren-Ereignis ausgelöst wird.',
  changeLoginPassword: 'Login-Passwort ändern',
  username: 'Benutzername',
  password: 'Passwort',
  passwordConfirm: 'Bitte Passwort erneut eingeben',
  usernameCannotBeEmpty: 'Benutzername darf nicht leer sein',
  passwordCannotBeEmpty: 'Passwort darf nicht leer sein',
  passwordNotConsistent: 'Die beiden eingegebenen Passwörter müssen übereinstimmen',
  usernameWithSpace: 'Benutzername darf keine Leerzeichen enthalten',
  passwordWithSpace: 'Passwort darf keine Leerzeichen enthalten',
  changePasswordSuccess: 'Die Änderung ist abgeschlossen.',
  loginDialog: 'Anmelden',
  login: 'Anmelden'
}



// WEBPACK FOOTER //
// ./src/locale/de-DE.js